import {
  deleteRequest,
  getRequest,
  postRequest
} from '../../Common/network-call';
import { INSTANCE_URL, APPUSER_GALLERY_FOLDER } from '../../Common/constant';

export const GALLERY_IMAGES = 'GALLERY_IMAGES';

export const fetchGalleryImages = (session, callback) => {
  var filter = encodeURI(`(eventid=${session.eventid})`);
  var orderby = encodeURI('displayorder ASC, createon DESC');
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/gallery?filter=(${filter})&order=${orderby}&include_count=true`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        dispatch({
          type: GALLERY_IMAGES,
          payload: { resource: res.resource }
        });
        callback({ success: 1, data: res.resource, count: res.meta.count });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const uploadGalleryImage = (session, values, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventifyscript/uploadGalleryImages`;
  let body = {
    filesArray: [values],
    eventid: session.eventid
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      res => {
        // dispatch(fetchGalleryImages(session, res => {}));
        callback({ success: 1, response: res });
      },
      error => {
        callback({ suucess: 0, response: error });
      }
    );
  };
};

export const deleteGalleryImage = (session, imageId, callback) => {
  let delUrl = `${INSTANCE_URL}/api/v2/eventify/_table/gallery/${imageId}`;

  return dispatch => {
    deleteRequest(
      delUrl,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
        dispatch(fetchGalleryImages(session, res => {}));
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};
